export default __webpack_public_path__ + "static/halloween-5-44d5c1bdb9f55e3de52d4d7031fb8124.svg";